import { LanguageLocaleCode } from '../i18n/i18n';

export const createParams = (locale: LanguageLocaleCode) => ({
  lang: locale,
});
